// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserSwitchOutlinedSvg from "@ant-design/icons-svg/es/asn/UserSwitchOutlined";
import AntdIcon from '../components/AntdIcon';

var UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserSwitchOutlinedSvg
  }));
};

UserSwitchOutlined.displayName = 'UserSwitchOutlined';
export default React.forwardRef(UserSwitchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UserSwitchOutlined.js
// module id = 2013
// module chunks = 0